
import { Vue, Options } from "vue-class-component";
import { languagesModule } from "@/store";
import { LanguagesInterface } from "@/types";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";
import BaseImage from "@/components/ui/BaseImage/Image.vue";

type Mode = "mobile" | "desktop";

@Options({
  name: "LanguageSwitch",
  components: { SvgIcon, BaseImage },
  props: {
    mode: {
      type: String as () => Mode,
      default: "desktop",
    },
  },
})
export default class LanguageSwitch extends Vue {
  private mode!: Mode;
  private isOpen = false;

  protected get availableLanguages(): LanguagesInterface[] {
    return languagesModule.getLanguages;
  }

  protected get currentLanguage(): string {
    return languagesModule.getActiveLanguage?.code || "en";
  }

  protected get currentLanguageName(): string {
    return languagesModule.getActiveLanguage?.name || "English";
  }

  protected get currentLanguageIcon(): string {
    return languagesModule.getActiveLanguage?.src || "";
  }

  protected get otherLanguages(): LanguagesInterface[] {
    return this.availableLanguages.filter(
      (lang) => lang.code !== this.currentLanguage
    );
  }

  protected get isLanguageLoaded(): boolean {
    const lang = languagesModule.getActiveLanguage;
    return Boolean(lang && lang.code && lang.name);
  }

  protected selectLanguage(langCode: string): void {
    this.navigateToLocale(langCode);
  }

  private onTrigger() {
    if (this.mode === "mobile") {
      this.isOpen = !this.isOpen;
    }
  }

  private navigateToLocale(newLocale: string): void {
    const { path, query, hash } = this.$route;
    const defaultLocale = "en";
    const segments = path.split("/").filter(Boolean);
    const validLocaleCode = languagesModule.getValidLanguageCodes;
    const hasLocale = segments.length > 0 && validLocaleCode.has(segments[0]);

    if (hasLocale) {
      segments.shift();
    }

    const corePath = segments.join("/");
    const prefix = newLocale === defaultLocale ? "" : `/${newLocale}`;
    const newPath = prefix + (corePath ? `/${corePath}` : "");

    if (newPath === path) return;

    this.$router.push({ path: newPath || "/", query, hash });
  }
}
